import { EventEmitter, Injectable } from '@angular/core';
import { BehaviorSubject, Observable, throwError } from 'rxjs';
import { ResponseCart, ResumenData } from '../../../core/model/DataCart';
import { DataAddCart, ProductCedis, ProductData, ResponseAddToCart } from '../../../core/model/Product.model';
import { environment } from '../../../../environments/environment';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { LoginService } from '../../login/login.service';
import { Router } from '@angular/router';
import { NotificacionesService } from './notifications/notificaciones.service';
import { ArticulosGuardadosService } from './articulos-guardados.service';
import { DataEncryptService } from '../crypto/data-encrypt.service';
import Swal from 'sweetalert2';
import { catchError, map, retry } from 'rxjs/operators';
import { DataUser } from '../../../models/generar_pedido/DataUser';
import { EmpresaService } from '../../Empresa/Empresa.service';

@Injectable({
  providedIn: 'root'
})
export class CartService {
  empresaId: string;

  public add = new EventEmitter<{}>();
  public continuarCart = new EventEmitter<boolean>(false);

  public cart = new BehaviorSubject<ProductData[]>([]);
  cart$ = this.cart.asObservable();

  public resumen = new BehaviorSubject<ResumenData>(null);
  resumen$ = this.resumen.asObservable();

  public tpCompra = new BehaviorSubject<string>(null); //contado - credito
  tpCompra$ = this.tpCompra.asObservable();

  public precioEnvio = new BehaviorSubject<number>(0); //contado - credito
  precioEnvio$ = this.precioEnvio.asObservable();

  public product: ProductData[] = [];
  public productAuxKbCoin: ProductData[] = []; //array auxilliar
  public goToCart = new BehaviorSubject<any>(null);

  //  goToCart sirve para enviar datos entre los componentes
  // Cuando no estes logueado agregar articulos a tu carrito de compras
  // despues en continuar te mandara al loguin una vez inicies sesion de
  // te debe de mandar al checkout
  public goToCart$ = this.goToCart.asObservable();
  //  ================================================
  private apiUrl = environment.apiUrl;
  public guardCheckout: boolean;

  constructor(
    private http: HttpClient,
    private loginService: LoginService,
    //private spinner: LoadingService, SUTITUIR POR SPINNER GENERICO
    //private swal: SwalService, SUSTITUIR SWAL.ERROR POR SWAL.FIRE
    private router: Router,
    private kabikCoins: NotificacionesService,
    private artGuardadosService: ArticulosGuardadosService,
    private dataEncryptService: DataEncryptService,
    private empresaService: EmpresaService
  ) {
    this.empresaService.empresaId$.subscribe(id => {
      this.empresaId = id;
    });
  }

  public addCart$ = (data: ProductData) => {
    // console.log('xxx_',data);
    if (this.product === null) {
      this.product = [];
    }
    this.product = [...this.product, data];
    this.updateKabicoinCart$(data, true, true);
    this.cart.next(this.product);
  };

  public addCartPG$ = (data: ProductData[]) => {
    this.product = [];
    this.product = data;
    // this.updateKabicoinCart$(data, true, true);
    this.cart.next(this.product);
  };

  private updateItemCart$ = (item: ProductData, data: any) => {
    this.product.forEach((product) => {
      if (
        product.ClaveArticuloProveedor === item.ClaveArticuloProveedor &&
        product.isCedis === data.IsCedis
      ) {
        product.CANT_CAR = data.qty;
      }
    });
    this.product = this.asignaExistenciaCedis$(this.product);
    this.updateKabicoinCart$(item, true, true);
    this.cart.next(this.product);
  };

  private checkKabicoinCart$ = (item: ProductData, check: boolean) => {
    this.updateKabicoinCart$(item, check, false); // Cuando entren al carrito va hacer false
    this.cart.next(this.product);
  };

  private updateKabicoinCart$ = (
    item?: ProductData,
    check?: boolean,
    update?: boolean
  ) => {
    let PuntosKabikCoin = 0;
    let TotalKabikCoin = 0;
    this.kabikCoins.kabikCoins$.pipe().subscribe((res: number) => {
      PuntosKabikCoin = res;
      if (!check) {
        // Si desmarca una item
        this.deleteItemKabikcoin(item);
      }
      if (PuntosKabikCoin > 0) {
        /**
         * Sumamos el total de los puntos kabikcoins seleccionaados
         * @variable TotalKabikCoin
         */
        TotalKabikCoin = this.totalAuxKabikCoins();
        this.product.forEach((product) => {

          /*
          *  solo se podran canjear articulos que sean de sucursal
          * los articulos de cdeis quedan desa habilitados
          */
          if (!product.isCedis) {

            // Productos del carrito
            // console.log('IS product',product);
            /**
             * Multiplicamos el total de puntos kabiCoins que vale el alrticulos * la
             * cantidad de articulos sea <= el total de puntos disponibles.
             * En caso de que mis puntos a canjear sea > a mis puntos kabiCoinsDisponibles
             * Opcion  #1
             * Si mis puntos kabiCoins * la cantidad de articulos en el carrito > puntosKabicoins
             * desabilitamos el check,Para que no pueda marcarlo si ya esta macado lo desmarcamos.
             * Opcion  #2
             * Si mis puntos kabiCoins * la cantidad de articulos en el carrito <= puntosKabicoins
             * hablitamos los check,paa que se pueda marcar.
             *
             * Ejemplos
             * (14.0000 * 1)<=50
             * (.0000 * 1) <=50
             * (1.0000 * 8) <=50
             *
             *
             */
            if (product.PuntosKBCoin * product.CANT_CAR <= PuntosKabikCoin) {
              // console.log('This linea 100');
              // console.log('('+product.PuntosKBCoin +'*'+ product.CANT_CAR+') <='+ PuntosKabikCoin);
              // console.log('Entro 101 '+PuntosKabikCoin + "?"+(product.PuntosKBCoin * product.CANT_CAR)+"<="+PuntosKabikCoin);
              /**
               * Cuando entra al carrito o recarga todos.Todos estan habilitados
               *  item = undefined & check = undefined
               *  quiere decir que recargo el carrito o acaba de entrar por primera vez
               */
              if (item !== undefined && check !== undefined) {
                /**
                 * (check && !update)
                 * Cuando se marca un check sobre el item para canjear los puntos kabiCoins.
                 * Por ejemplo
                 * Al querer canjear un articulo y  los puntos kabiCoins del articulo son menores al total de mis puntos kabiCoins.
                 *
                 * @variable check:boolean;
                 * @variable update:boolean;
                 *
                 */
                if (check && !update) {

                  /**
                   *
                   * TRUE Y FALSE CUANDO HACEMOS CHECK EN EL ITEM y no en el simbolo de mas
                   *
                   *  Buscamos en el arreglo this.product la posicion del item para actualizar
                   * pagarConKabiCoin a true y DisabledKabikCoin a true;
                   *
                   *   @variable posc:number posicion que me ayudara a actualizar el item en el arreglo this.products
                   *
                   */
                  const posc = this.product.indexOf(item);
                  /**
                   * Sumamos los puntos kabiCoins que ya tengo
                   * seleccionado con los puntos kabiCoins que acabo de marcar.
                   * @variable cant =  (Total de kabiCoins seleccionados) + (puntos kabicoins de inte seleccionado * la cantidad)
                   * ejemplo
                   * (20) + (10 * 2) = 20 + 20 = 40.
                   *
                   *
                   */

                  const cant = TotalKabikCoin + item.PuntosKBCoin * item.CANT_CAR;
                  if (posc !== -1) {
                    //Buscamos que el item seleccionado exista en this.products

                    /**
                     *
                     * Si los puntos que tengo marcados sumado con los puntos que acabo de seleccionar
                     * es menor igual al total de mis puntos actualizo el parametro pagarConKabiCoins a true
                     * quiere deci que si me alcanza para pagar el articulo con kabiCoins.
                     */
                    // 20             + (  10             *    2 ) <=       50
                    // (TotalKabikCoin + (item.PuntosKBCoin * item.CANT_CAR))
                    //  console.log(TotalKabikCoin + (item.PuntosKBCoin * item.CANT_CAR));
                    if (cant <= PuntosKabikCoin) {
                      // console.log(cant);
                      if (this.productAuxKbCoin.indexOf(product) === -1) {
                        // Si no existe lo agregamos
                        if (product.ClaveArticuloProveedor === item.ClaveArticuloProveedor) {
                          this.productAuxKbCoin = [
                            ...this.productAuxKbCoin,
                            item,
                          ];
                          this.product[posc].PagarConKabikCoin = true;
                          this.product[posc].DisabledKabikCoin = true;
                        }
                      }
                    }
                  }
                  if (product.ClaveArticuloProveedor !== item.ClaveArticuloProveedor) {
                    // los que estan en check ya no los sumo :O
                    // console.log(product)
                    // console.log(this.productAuxKbCoin.indexOf(product));
                    // console.log(this.productAuxKbCoin)

                    /**Sumamos todos los articulos el que estamos marcando.
                     * Por ejemplo si marque un item de 42 puntos kabiCoins y tengo en total 50 kabicoins
                     * Sumo los 42 puntos con  los puntos que tengo en la lista y si es mayor que mis puntos kabiCoins lo desabilito
                     * ejemplo seleccione un articulo de 42 puntos
                     * y tengo en mi carrito 3 artiuculos
                     *  articulo 10 kabicoins
                     *  articulo 8 kabicoins
                     *  articulo de 100 kabicoins
                     * 42 + 10 > 50 SI ES MAYOR SE DESABILITA
                     * 42 + 8 > 50 NO AUN TE ALCANZA PARA CANJEAR kabiCoins
                     * 42 + 50 > 50 SI ES MAYOR SE DESABILITA
                     */

                    if (this.productAuxKbCoin.indexOf(product) == -1) {
                      if (
                        cant + product.PuntosKBCoin * product.CANT_CAR >
                        PuntosKabikCoin
                      ) {
                        // console.log('Entro a kabiCoins');
                        // console.log((cant+(product.PuntosKBCoin * product.CANT_CAR)))
                        product.PagarConKabikCoin = false;
                        product.DisabledKabikCoin = false;
                      }
                    }
                  }
                } else {
                  // Cuando tiene el check marcado y actualiza el articulo
                  // console.log('Entro al else');
                  /*
                   * Cuando tienen el check y actualiza
                   */
                  // console.log(check);
                  if (check && update) {
                    // cuando act
                    // console.group('Linea 226');
                    // console.log('this update');
                    // console.log('Cuando actualiza o agrega un nuevo item')
                    // if (product.ClaveArticulo === item.ClaveArticulo) {
                    const poscAux = this.product.indexOf(item);
                    let itemAux = 0;
                    if (poscAux !== -1) {
                      itemAux =
                        this.product[poscAux].PuntosKBCoin *
                        this.product[poscAux].CANT_CAR;
                    }
                    if (product.ClaveArticuloProveedor === item.ClaveArticuloProveedor) {
                      // console.group('Son iguales 231')
                      //   console.log(product);
                      // console.log('product.es igual');
                      let taux = 0;
                      /**
                       *  Multiplicamos los puntos kabicoins del articulo por
                       *  la cantidad de articulos agregados al carrito
                       *  @variable taux = 0 ;
                       */
                      if (!item.PagarConKabikCoin) {
                        /**
                         * Si no esta marcado y agregamos o restamos articulos
                         * sumamos lo que ya estan marcandos.
                         */
                        // console.log('Entro aqui PagarConKabikCoin');
                        taux = item.PuntosKBCoin * item.CANT_CAR;

                        // console.log('IF '+taux);
                      }

                      /**
                       *    Si el total de lo que ya tengo marcado + lo que estoy actualizando es <= que el total de puntos kabicoins
                       *    habilito el check si no lo desabilito,
                       */
                      //  console.log(TotalKabikCoin+'+'+taux+'<='+PuntosKabikCoin);
                      // console.log('A8x');
                      if (TotalKabikCoin + taux <= PuntosKabikCoin) {
                        // console.log('if'+(TotalKabikCoin+taux)+'<='+PuntosKabikCoin)
                        product.DisabledKabikCoin = true;
                      } else {
                        // console.log('else'+(TotalKabikCoin+taux)+'<='+PuntosKabikCoin)

                        product.DisabledKabikCoin = false;
                        /*
                         * si ya esta marcado los desmarcamos y lo eliminamos de productAuxKbCoin
                         */
                        if (product.PagarConKabikCoin) {
                          product.PagarConKabikCoin = false;
                          this.deleteItemKabikcoin(product);
                        }
                      }
                      // console.groupEnd();
                    } else {

                      // TotalKabikCoin_ = 0;
                      const TotalKabikCoinAux = this.totalAuxKabikCoins(); // -itemAux; //TotalKabikCoin
                      //  console.log('total de los puntos kabikCoin ',TotalKabikCoin)
                      //  console.log('Puntos actualizados despues de eliinar  ', TotalKabikCoin_)
                      //  console.log('Primer item seleccionado kabiCoins',itemAux,' Resta ',TotalKabikCoin - itemAux)
                      //  console.log('este es el array product ',product);
                      //  console.log('este es el array item ',item);

                      if (!product.PagarConKabikCoin) {
                        // console.log('Este es el array item desabilitado ',product);
                        if (
                          TotalKabikCoinAux +
                          product.PuntosKBCoin * product.CANT_CAR <=
                          PuntosKabikCoin
                        ) {
                          // console.log('Entro al if');
                          product.DisabledKabikCoin = true;
                        } else {
                          product.DisabledKabikCoin = false;
                          // product.PagarConKabikCoin = false;
                          // /**
                          // * si ya esta marcado los desmarcamos y lo eliminamos de productAuxKbCoin
                          // */
                          if (product.PagarConKabikCoin) {
                            product.PagarConKabikCoin = false;
                            this.deleteItemKabikcoin(product);
                          }
                        }
                      }
                      //  console.groupEnd();
                    }
                  } else {
                    /**
                     * Cuando desmarca un item
                     * validamos que ese item exista en nuestro arreglo de productsAuxKbCoin
                     * si existe acualizamos el item.pagarConKabiCoin a false
                     *  si es menor  habilitamos el check
                     *  si es mayor lo desabilitamos
                     *
                     */
                    let totalAuxKb = 0;
                    if (this.productAuxKbCoin.indexOf(product) === -1) {
                      if (product.ClaveArticuloProveedor === item.ClaveArticuloProveedor) {
                        product.PagarConKabikCoin = false;
                      }
                      totalAuxKb =
                        TotalKabikCoin + product.PuntosKBCoin * product.CANT_CAR;
                      if (totalAuxKb <= PuntosKabikCoin) {
                        product.DisabledKabikCoin = true;
                      } else {
                        product.PagarConKabikCoin = false;
                        product.DisabledKabikCoin = false;
                      }
                    }
                  }
                }
              } else {
                /**
                 * Se agrego este else Cuando incia por primera vez todos estan habilitados
                 *
                 */
                product.DisabledKabikCoin = true;
              }
            } else {
              // Opcion  #1
              /**
               * Si quiere canjear 20 puntos kabiCoins y tiene 5 puntos desabilitamos el check.
               *  y si el check ya lo tiene marcado lo desmarcamos.
               * cantidad de articulos sea <= el total de puntos disponibles
               */
              product.DisabledKabikCoin = false;
              if (product.PagarConKabikCoin) {
                product.PagarConKabikCoin = false;
                this.deleteItemKabikcoin(product);
              }
            }
          } else {
            product.DisabledKabikCoin = false;
            product.PagarConKabikCoin = false;
          }
        });
      } else {
        // Se agrego esta linea 167
        /**
         * Si tiene 0 puntos kabiCoins desabilitamos el check para que pueda canjear.
         * Si no tiene puntos kabiCoins desabilitamos los checks este recorrido lo hace con todos.
         */
        this.product.forEach((product) => {
          product.DisabledKabikCoin = false;
        });
      }
      this.cart.next(this.product); // actualizamos la informacion
    }); /* Fin del subscribe kabiCoins*/
  };

  /**
   * start-element handler
   *
   * @param item Item del articulo
   * @param check checkbox si marcan = true desmarcan = false.
   * @param update Si actualizan un item. false si no agregan mas true si agregan mas cantidades al carrito.
   */

  private deleteItemKabikcoin = (item: ProductData) => {
    // console.log('is item=> ',this.productAuxKbCoin);
    const removeItem = this.productAuxKbCoin.indexOf(item);
    if (removeItem !== -1) {
      this.productAuxKbCoin.splice(removeItem, 1);
    }
  };

  private totalAuxKabikCoins = (item?: ProductData): number => {
    let TotalKabikCoin = 0;
    this.productAuxKbCoin.forEach((data) => {
      if (item !== undefined) {
        if (data.ClaveArticuloProveedor !== item.ClaveArticuloProveedor) {
          // Sumamos todos los puntos kabiCoins que tenemos menos los puntos que van o ocupar por ejemplo
          TotalKabikCoin = TotalKabikCoin + data.PuntosKBCoin * data.CANT_CAR; //  4 * 12 ;
        }
      } else {
        // Sumamos todos los aticulos que tenemos  marcados.
        TotalKabikCoin = TotalKabikCoin + data.PuntosKBCoin * data.CANT_CAR;
      }
    });
    return TotalKabikCoin;
  };
  /*
     deleteItemCart
     Item: array que se va eliminar
     this.product  arreglo de todos los artiuculos
  */
  private deleteItemCart$ = (item: ProductData) => {
    let arrayAux = [];
    const arrayKabikcoinsAux = [];
    const index = this.product.indexOf(item);
    arrayAux = this.product.filter((event) => {
      return event !== item;
    });

    this.productAuxKbCoin.forEach((product) => {
      if (product.ClaveArticuloProveedor !== item.ClaveArticuloProveedor) {
        arrayKabikcoinsAux.push(product);
      }
    });
    this.productAuxKbCoin = arrayKabikcoinsAux;
    this.product = arrayAux;
    this.product = this.asignaExistenciaCedis$(this.product);
    localStorage.setItem('items-cart-login', JSON.stringify(this.product));
    this.cart.next(this.product);
  };
  /**
   * Cuando se le da click en Vaciar Cesta
   * borra todo el carrito de compras del cliente
   */
  private deleteCart$ = () => {
    this.product = [];
    this.productAuxKbCoin = [];
    this.cart.next(this.product);
  };
  public refreshCart$ = () => {
    this.cart.next(this.product);
  };
  public cleanCart$ = () => {
    this.product = [];
    this.productAuxKbCoin = [];
    this.cart.next(this.product);
  };

  public validaExistencias$ = (): { existenciasCedis: number, existenciasSucursal: number, concactClaves: string, product: ProductData[] } => {
    let existenciasCedis = 0;
    let existenciasSucursal = 0;
    let concactClaves = '';
    this.product.forEach((item: ProductData) => {

      if (item.isCedis) {
        if (item.ExistenciasCedis <= 0) {
          existenciasCedis++;
          concactClaves = item.ClaveArticuloProveedor + ',' + concactClaves;
        }
      }
      else {
        if (item.ExistenciasSucursal <= 0) {
          existenciasSucursal++;
          concactClaves = item.ClaveArticuloProveedor + ',' + concactClaves;
        }
      }
    });
    return { existenciasCedis, existenciasSucursal, concactClaves, product: this.product };
  }

  // ********************************
  // ********************************
  // METODO PARA HACER EL CALCULO
  // DE LOS PRODUCTOS
  // ********************************
  // ********************************
  public calcularResumen = (data: ProductData[]): ResumenData => {
    let subTotal = 0;
    let iva = 0;
    let comision = 0;
    let totalRecibido = 0;
    let subTotalProduct = 0;
    let totalVenta = 0;
    let totalKbCoins = 0;
    let puntosKabikCoinDispo = 0;
    let envio = 0;
    let modificaPrecioEnvio: boolean;

    const tipoImpuesto = this.getTipoImpuesto(); // Default dejarlo en 0.16. Impuesto nacional
    // let descuento = 0;
    const tpPago = localStorage.getItem('tipo-pago');

    this.kabikCoins.kabikCoins$.pipe().subscribe((res: number) => {
      puntosKabikCoinDispo = res;
    });

    const pasarela = localStorage.getItem('pasarela-pago');
    const dataUser = this.loginService.getDataClientePedido();
    const metodoDeEntregaEnvioaDomicilio = JSON.parse(localStorage.getItem('opcion-metodo-entrega'));
    //console.log('metodoDeEntregaEnvioaDomicilio',metodoDeEntregaEnvioaDomicilio);
    data =
      data === null
        ? JSON.parse(localStorage.getItem('items-cart-login'))
        : data;

    // if (this.loginService.isLogged()) {
    //   if (dataUser.es_publicogeneral === 'NO') {
    //     // el costo del envio puede variar.
    //     if (Number(localStorage.getItem('envio-cart-login')) === 104.39) {
    //       localStorage.removeItem('envio-cart-login');
    //    }
    //   }
    // }

    // Solo si selecciona envio a docimilio en articulos de cedis o sucursal se agregara el precio de envio
    if (this.loginService.isLogged()) {
      if (dataUser.es_publicogeneral === 'NO') { // distribudior solo si el cliente selecciona metodo de envio a domocilio.
        if (metodoDeEntregaEnvioaDomicilio?.checkCedis || metodoDeEntregaEnvioaDomicilio?.checkSucursal) {
          envio = Number(localStorage.getItem('envio-cart-login'));
          modificaPrecioEnvio = metodoDeEntregaEnvioaDomicilio?.tipoEnvioSucursal === 'envioDomicilio' ? true : false;
          //  console.log('is if disitribuidor   ****',envio);
        }
      } else { // publico general siempre add el precio del envio.
        envio = Number(localStorage.getItem('envio-cart-login'));
        // console.log('is else publico   ****',envio);

      }
    } else { // es cliente publico general.
      envio = Number(localStorage.getItem('envio-cart-login'));
      //  console.log('is else  no logged  envio ****',envio);
    }
    if (data) {
      data.forEach((product) => {
        // Sacamos los precios de los productos y los multiplicamos por la cantidad seleccionada
        // Si el check esta activo actualizamos el subtotal
        // const cantidad =
        //   product.PagarConKabikCoin === true ? 0 : product.CANT_CAR; //  product.CANT_CAR; Cantidad
        // totalKbCoins =
        //   product.PagarConKabikCoin === true
        //     ? totalKbCoins + product.PuntosKBCoin * product.CANT_CAR
        //     : totalKbCoins + 0;
        const cantidad = product.CANT_CAR;
        totalKbCoins = product.PagarConKabikCoin === true ? totalKbCoins + product.PuntosKBCoin * product.CANT_CAR : totalKbCoins + 0;
        const precio = product.PagarConKabikCoin === true ? 0.01 : (Number(product.PrecioNormal) >= Number(product.PrecioVenta) ? product.PrecioVenta : product.PrecioNormal)
        // precio  -- Se hace esta validacion por si el articulo tiene promocion
        // const precio =
        //   Number(product.PrecioNormal) >= Number(product.PrecioVenta)
        //     ? product.PrecioVenta
        //     : product.PrecioNormal;
        // Se modifico el precio cuando se haga el canje con kbC no se puede facturar con precio 0.
        // precio =  product.PagarConKabikCoin===true ? 0.01:precio;
        // se multiplica la cantidad por el precio obtenido
        subTotal = subTotal + precio * cantidad;
      });
      if (data.length > 0) {
        subTotalProduct = subTotal;
        if (modificaPrecioEnvio) {
          if (subTotalProduct >= 1000) {
            envio = 0.01;
          } else if (subTotalProduct < 1000) {
            envio = 50;
          }
        }
        subTotal = envio ? subTotal + Number(envio) : subTotal + 0;
        totalRecibido = subTotal;

        if (this.loginService.isLogged()) {
          // PG o Distribuidor loged
          if (dataUser.es_publicogeneral === 'SI') {
            // Publico General
            iva = (subTotal - Number(envio) - Number(comision)) * tipoImpuesto;
            const subComision = subTotal + iva;
            comision = this.calcularComision(pasarela, subComision);
            subTotal = subTotal + iva + comision;
            totalVenta = subTotal;
          } else {
            // Distribuidor
            /**
             * El calculo de la comision solo esta disponible con compras a contado.
             */
            if (tpPago === 'contado') {
              comision = this.calcularComision(pasarela, subTotal);
            }
            subTotal = subTotal + comision;
            iva = subTotal * tipoImpuesto;
            totalVenta = subTotal + subTotal * tipoImpuesto;
          }
        } else {
          iva = (subTotal - Number(envio) - Number(comision)) * tipoImpuesto;
          totalVenta = subTotal + iva;
        }
      }
      const resultResume = {
        subTotalProduct,
        subTotal,
        envio: envio ? Number(envio) : 0, // si el envio no exite le mandamo CERO
        comision,
        iva, //: subTotal * 0.16,
        subTotalRecibido: comision > 0 ? subTotal - comision : subTotal,
        totalRecibido,
        total: totalVenta, // subTotal + (subTotal * 0.16)
        totalKbCoins,
        puntosKbCoinsDisponibles: puntosKabikCoinDispo - totalKbCoins,
        misPuntosKabiCoin: puntosKabikCoinDispo,
      };
      //  console.log('is envio::',envio)
      //  console.log(resultResume);
      this.resumen.next(resultResume);
      return resultResume;
    }
  };
  // ********************************
  // ********************************
  // METODO PARA CALCULAR LA COMISION
  // DE LAS PASARELAS DE PAGO
  // ********************************
  // ********************************
  public calcularComision = (pasarela: string, subtotal: number): number => {
    return 0;
    /*switch (pasarela) {
      case 'paypal':
        localStorage.setItem(
          'comision-cart-login',
          String((subtotal * 0.042 + 4) * 1.16)
        );
        return (subtotal * 0.042 + 4) * 1.16;
      case 'stripe':
        localStorage.setItem(
          'comision-cart-login',
          String((subtotal * 0.036 + 3) * 1.16)
        );
        return (subtotal * 0.036 + 3) * 1.16;
      case 'mercadopago':
        localStorage.setItem(
          'comision-cart-login',
          String((subtotal * 0.0365 + 4) * 1.16)
        );
        return (subtotal * 0.0365 + 4) * 1.16;
      default:
        return 0;
    }*/
  };
  private getTipoImpuesto(): number { // funcion que retorna el tipo de impuesto del cliente.
    // let tipoImpuesto = 0.16; // Default dejarlo en 0.16. Impuesto nacional
    if (this.loginService.isLogged()) {
      const dataUser = this.loginService.getDataClientePedido();
      if (dataUser.tipoImpuesto > 0 && dataUser.tipoImpuesto !== null && dataUser.tipoImpuesto !== undefined) {
        return dataUser.tipoImpuesto;
      }
      return 0.16; // Si no tiene el tipo de inpuesto asignado.
    }
    return 0.16;
  }

  public getminiCartInvitado = () => {

    this.product = [];
    this.cart.next(this.product); // limpiamos la variable del Observable, esto es para que lleguen los datos limpios
    const data = JSON.parse(localStorage.getItem('items-cart-login'));
    this.cart.next(null);
    this.cart.next(data);
    this.product = data;
  };
  // ********************************
  // ********************************
  // ********     HTTPS      ********
  // ********************************
  // ********************************
  public addNewLisyItemCart = (listArticulos: any): Observable<ResponseCart> => {
    console.log('listArticulos: ', listArticulos);
    const dataCliente = this.loginService.getDataClientePedido();
    const dataQuery = {
      // p : environment.production,
      listArticulos,
      client_id: dataCliente.client_number,
      almacen_id: dataCliente.almacenPre,
      empresa_id: this.empresaId,
      uid: dataCliente.uid,
      publicoGeneral: dataCliente.es_publicogeneral,
      correo: dataCliente.email,
      option: 'addCartMultipleItems',
    };
    return this.http
      .post<any>(this.apiUrl + 'Servicios-web/Cart/CartV2.php', dataQuery)
      .pipe(
        map((response) => {
          listArticulos.forEach((articulo) => {
            this.addCart$(articulo);
          });
          return response;
        })
      );
  };

  public addItemCart = (item: DataAddCart, productData?: ProductData) => {
    const dataCliente = this.loginService.getDataClientePedido();
    const dataquery = {
      article_id: item.ClaveArticulo,
      qty: item.Cantidad,
      client_id: dataCliente.client_number,
      almacen_id: item.AlmacenID,
      empresa_id: this.empresaId,
      uid: dataCliente.uid,
      publicoGeneral: dataCliente.es_publicogeneral,
      correo: dataCliente.email,
      option: 'addCart',
      isCedis: item.isCedis,
      productData,
    };
    return this.http
      .post<ResponseAddToCart>(
        this.apiUrl + 'Servicios-web/Cart/CartV2.php',
        dataquery
      )
      .pipe(map((response) => response));
  };

  public getminiCart = (): Observable<ResponseCart> => {
    // this.goToCart.next(false);
    const cliente: DataUser = this.loginService.getDataClientePedido();
    const dataQuery = {
      client_id: cliente.client_number,
      empresa_id: this.empresaId,
      almacen_id: cliente.almacenPre,
      // publico en general
      uid: cliente.uid,
      publicoGeneral: cliente.es_publicogeneral,
      correo: cliente.email,
      option: 'getCart',
    };
    this.product = [];
    this.cart.next(this.product); // limpiamos la variable del Observable, esto es para que lleguen los datos limpios
    return this.http
      .post<ResponseCart>(
        this.apiUrl + 'Servicios-web/Cart/CartV2.php',
        dataQuery
      )
      .pipe(
        retry(3),
        catchError(this.handleError),
        map((res) => {
          if (!res.error) {
            console.log("respuesta getminicart", res)
            this.cart.next(null);
            this.product = this.asignaExistenciaCedis$(res.respuesta);
            this.cart.next(this.product);
            this.updateKabicoinCart$();
            this.artGuardadosService.updateArtGurdados$(res.articulosGuardados);
          } else {
            this.swalError(
              'Canasta de compras',
              'Ocurrio un error al momento de mostrar bolsa' +
              '<br/><br/><div style="font-size: 14px;"><p>Número de cliente: ' +
              cliente.client_number +
              '<br/>Nombre: ' +
              cliente.company_name +
              '<br/>Correo electrónico: ' +
              cliente.email +
              '<br/>Almacén: ' +
              cliente.almacenPre +
              '</p></div>'
            );
          }
          return res;
        })
      );
  };
  /**
   * Metodo para actualizar la cantidad del articulo
   * @param item este parametro es el que contiene la nueva cantidad y la clave del articulo que se va a afectar
   * @param product este parametro es el que contiene el articulo con los datos sin actualizar los
   */
  public updateCartItemsQty = (item, product: ProductData) => {
    const cliente: DataUser = this.loginService.getDataClientePedido();
    const dataQuery = {
      article_id: item.ClaveArticuloProveedor,
      qty: item.qty,
      client_id: cliente.client_number,
      almacen_id: item.AlmacenID,
      empresa_id: this.empresaId,
      cedis: item.IsCedis,
      // publico en general
      uid: cliente.uid,
      publicoGeneral: cliente.es_publicogeneral,
      correo: cliente.email,
      option: 'updateCart',
    };
    return this.http
      .post<ResponseCart>(
        this.apiUrl + 'Servicios-web/Cart/CartV2.php',
        dataQuery
      )
      .pipe(
        map((response) => {
          if (!response.error) {
            this.updateItemCart$(product, item);
            this.updateItemCart$(product, item);
          } else {
            this.swalError(
              'Canasta de compras',
              'Ocurrio un error al momento de actualizar la cantidad del artículo' +
              '<br/><br/><div style="font-size: 14px;"><p>Número de cliente: ' +
              cliente.client_number +
              '<br/>Nombre: ' +
              cliente.company_name +
              '<br/>Correo electrónico: ' +
              cliente.email +
              '<br/>Almacén: ' +
              cliente.almacenPre +
              '</p></div>'
            );
          }
          return response;
        })
      );
  };
  /**
   * Metodo para actualizar la cantidad del articulo
   * Este metodo es solo para cuando el usaurio no esta logueado
   * Recibe los mismos parametros que el metodo @updateCartItemsQty
   */
  public updateCartItemsQtyInvite = (item, product: ProductData) => {
    this.updateItemCart$(product, item);
  };
  /**
   * Metodo para eliminar un articulo del carrito
   * @param item este parametro es el que recibe el articulo que se va a eliminar
   */
  public removeItemToCart = (item: ProductData) => {
    const cliente: DataUser = this.loginService.getDataClientePedido();
    const article = {
      // p : environment.production,
      article_id: item.ClaveArticuloProveedor,
      client_id: cliente.client_number,
      empresa_id: this.empresaId,
      almacen_id: cliente.almacenPre,
      cedis: item.isCedis,
      // publico en general
      uid: cliente.uid,
      publicoGeneral: cliente.es_publicogeneral,
      correo: cliente.email,
      option: 'deleteCart',
    };
    return this.http
      .post<ResponseCart>(this.apiUrl + 'Servicios-web/Cart/CartV2.php', article)
      .pipe(
        map((response) => {
          if (!response.error) {
            this.deleteItemCart$(item);
          } else {
            this.swalError(
              'Canasta de compras',
              'Ocurrio un error al momento de eliminar el artículo' +
              '<br/><br/><div style="font-size: 14px;"><p>Número de cliente: ' +
              cliente.client_number +
              '<br/>Nombre: ' +
              cliente.company_name +
              '<br/>Correo electrónico: ' +
              cliente.email +
              '<br/>Almacén: ' +
              cliente.almacenPre +
              '</p></div>'
            );
          }
          return response;
        })
      );
  };

  public setPrecioPaqueteria(precio: number) {
    this.precioEnvio.next(precio);
  }


  public CheckKabikCoin = (item: ProductData, check: boolean) => {
    //item y si tru o false
    this.checkKabicoinCart$(item, check);
  };

  /**
   * Metodo para eliminar un articulo del carrito
   * Este metodo es solo para cuando el usaurio no esta logueado
   * Recibe los mismos parametros que el metodo @removeItemToCart
   */
  public deleteItemToCartInvite = (item: ProductData) => {
    this.deleteItemCart$(item);
  };
  /**
   * Metodo para destruir el carrito completo
   * Este metodo elimina todo los articulos del carrito
   * Los elimina desde la base de datos como de la variable global @cart
   */
  public deleteCart = () => {
    const cliente: DataUser = this.loginService.getDataClientePedido();
    const dataQuery = {
      // p : environment.production,
      client_id: cliente.client_number,
      empresa_id: this.empresaId,
      uid: cliente.uid,
      publicoGeneral: cliente.es_publicogeneral,
      correo: cliente.email,
      delete_all: true,
      option: 'deleteCart',
    };
    return this.http
      .post<ResponseCart>(
        this.apiUrl + 'Servicios-web/Cart/CartV2.php',
        dataQuery
      )
      .pipe(
        map((resp) => {
          if (!resp.error) {
            this.deleteCart$();
            
          } else {
            this.swalError(
              'Canasta de compras',
              'Ocurrio un error al momento de actualizar la cantidad del artículo' +
              '<br/><br/><div style="font-size: 14px;"><p>Número de cliente: ' +
              cliente.client_number +
              '<br/>Nombre: ' +
              cliente.company_name +
              '<br/>Correo electrónico: ' +
              cliente.email +
              '<br/>Almacén: ' +
              cliente.almacenPre +
              '</p></div>'
            );
          }
          return resp;
        })
      )
      .toPromise();
  };
  /**
   * Cuando se le da click en Vaciar Cesta
   * borra todo el carrito de compras del cliente.
   */
  public deleteCartIsNotLoguin = () => {
    //Funcion para eliminar todos los articulos del carrito cuando uan no esta logueado.

    this.deleteCart$();
    
    return true;
  };

  /**
   * Metodo para destruir el carrito completo.
   * Metodo que se utiliza cuando se hace el pedido y queremos limpiar el carrito.
   * Este metodo no te redirecciona a ningu lado, El anterior te envia al Home
   */
  public destroyCart = () => {
    const cliente: DataUser = this.loginService.getDataClientePedido();
    const dataQuery = {
      // p : environment.production,
      client_id: cliente.client_number,
      empresa_id: this.empresaId,
      delete_all: true,
      // publico en general
      uid: cliente.uid,
      publicoGeneral: cliente.es_publicogeneral,
      correo: cliente.email,
      option: 'deleteCart',

    };

    return this.http
      .post<ResponseCart>(this.apiUrl + 'Servicios-web/Cart/CartV2.php', dataQuery)
      .pipe(
        map((resp) => {
          if (!resp.error) {
            this.deleteCart$();
            return resp;
          }
        })
      )
      .toPromise();
  };
  /**
   * Metodo que revisa si el usuario tiene credito
   * Solo se utiliza en distribuidores
   */
  public checkCredit = () => {
    const cliente: DataUser = this.loginService.getDataClientePedido();
    const data = {
      empresaID: this.empresaId,
      clientID: cliente.client_number,
    };
    let encrypt = this.dataEncryptService.getEncrypt(data);
    encrypt = JSON.parse(encrypt);
    const request = {
      option: "getCredito",
      data: encrypt
    }
    console.log("DATOS ENCRIPTADOS", request)
    return this.http
      .post<any>(this.apiUrl + 'Servicios-web/Cliente/server.php', request)
      .pipe(retry(3),
        catchError(this.handleError), map((response) => response));
  };

  /**  Optiene el precio de la paqueteria */

  public getPrecioPaqueteria = () => {

    const cliente: DataUser = this.loginService.getDataClientePedido();
    const isLogged = this.loginService.isLogged();

    const data = {
      empresaID: this.empresaId,
      clientID: cliente.client_number,
    };
    let encrypt = this.dataEncryptService.getEncrypt(data);


    encrypt = JSON.parse(encrypt);
    const request = {
      option: "getPrecioPaqueteria",
      data: encrypt
    }
    return this.http
      .post<any>(this.apiUrl + 'Servicios-web/Cliente/server.php', request)
      .pipe(retry(3), catchError(this.handleError), map((response) => response));

  }

  public asignaExistenciaCedis$ = (product: ProductData[]): ProductData[] => {
    const maximoDePrioridades = [1, 2, 3];
    product.forEach((value: ProductData) => {
      if (value.isCedis) {
        const cantidadCarrito = value.CANT_CAR;
        let cantidadRepartida = false;
        let bandera = false; // Valida si ya fue repartida una cantidad
        value.Cedis.forEach((cedi: ProductCedis) => {
          console.log('is kabik here?', cedi.Proveedor)
          if (Number(cedi.Habilitado) === 1 && cedi.Proveedor !== 'KABIK') {
            console.log('is kabik here?', cedi.Proveedor)
            // No debemos asignarle piezas del iinventario cedias al invenrario sucursal.
            // Validamos que este hablitado.
            maximoDePrioridades.forEach((prioridad) => {
              // Tomamos las primeras 3 prioridades
              if (Number(cedi.Prioridad) === prioridad) {
                if (cantidadCarrito <= cedi.TotalExistencias) {
                  if (cantidadRepartida === false) {
                    cedi.CantidadSeleccionada = cantidadCarrito;
                    cantidadRepartida = true;
                    bandera = true;
                  } else {
                    cedi.CantidadSeleccionada = 0;
                  }
                } else {
                  cantidadRepartida = false;
                  cedi.CantidadSeleccionada = 0;
                }
              }
            });
          }
        });

        if (bandera === false) {
          // quiere decir que ninguno de los articulos tiene existencias suficientes por lo que se va repartir entre todos las
          // empresas disponibles.
          // Hago un contador tipo 0
          // ejemplo si tengo 6 por agregar
          // Si es lo que tengo es <= a mi existencias tomo mis existencias
          // despues empiezo a sumar el contador
          let cantidadCount = 0;
          let cantAuxiliar = 0;
          value.Cedis.forEach((cedi: ProductCedis) => {
            if (Number(cedi.Habilitado) === 1 && cedi.Proveedor !== 'KABIK') {
              // console.log('Linea 286');
              maximoDePrioridades.forEach((prioridad) => {
                if (Number(cedi.Prioridad) === prioridad) {
                  cantidadCount =
                    Number(cantidadCount) + Number(cedi.TotalExistencias);
                  if (cantidadCount <= cantidadCarrito) {
                    cedi.CantidadSeleccionada = Number(cedi.TotalExistencias);
                    cantAuxiliar = cantidadCarrito - cantidadCount;
                  } else {
                    cedi.CantidadSeleccionada = cantAuxiliar;
                    cantAuxiliar = 0;
                  }
                }
              });
            }
          });
        }
      }
    });
    return product;
  };
  private handleError = (error: HttpErrorResponse | any) => {
    Swal.fire({
      type: 'error',
      title: 'Canasta de compras',
      html: 'Lo sentimos, ocurrio un error de comunicación.<br/><br/>Error: ' +
        error.message + ' | ' + error?.error?.message,
      confirmButtonColor: '#E52325',
      confirmButtonText: 'Aceptar',
      footer: 'Contáctanos&nbsp;<a href="mailto:incidencias@integradora.net">incidencias@integradora.net</a>'
    })
    return throwError(error);
  };

  private swalError = (title: string, text: string) => {
    Swal.fire({
      type: 'error',
      title,
      html: text,
      confirmButtonColor: '#e52325',
      confirmButtonText: 'Aceptar',
      footer: 'Contáctanos&nbsp;<a href="mailto:incidencias@integradora.net">incidencias@integradora.net</a>'
    });
  }
}
